<div class="container">
    <app-solicitud-servicio 
        [title]="'Seguimiento de solicitudes de servicio'"
        [$views]="5"
        [reloadTable]="reloadTable"
        (codeSolicitud)="codeSolicitud = $event"
        (cancelSolicitudDisponible)="onCancel($event ? cancel : null)"
        (solicitudDisponibleSeleccionada)="solicitudSeleccionada = $event">
    </app-solicitud-servicio>

    <div class="d-flex flex-row justify-content-end">
        <button class="btn btn-secondary col-3" [routerLink]="['/create-solicitud-servicio']">REGRESAR</button>
    </div>
    <br>
</div>





<!-- MODAL CANCELACION DE LA SOLICITUD DEL SERVICIO -->
<ng-template #cancel let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title text-secondary" id="modal-basic-title">
            <strong class="text-secondary">Cancelación de la solicitud del servicio</strong>
        </h4>
    </div>

    <div class="modal-body py-3">
        <app-cancelar-solicitud-servicio
            [codeSolicitud]="codeSolicitud"
            [solicitudDisponibleSeleccionada]="solicitudSeleccionada"
            (cancel)="onValidate($event)"
            (reloadTable)="reloadTable = $event">
        </app-cancelar-solicitud-servicio>
    </div>
</ng-template>